import { render } from "./UploadMedia.vue?vue&type=template&id=fd03878c&scoped=true"
import script from "./UploadMedia.vue?vue&type=script&lang=js"
export * from "./UploadMedia.vue?vue&type=script&lang=js"

import "./UploadMedia.vue?vue&type=style&index=0&id=fd03878c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd03878c"]])

export default __exports__